import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import AuthService from './AuthService.js';

class LoginCreateSession extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    // state variables here
    this.state = {
    };
    autoBind(this);

    if(this.props.username != null && this.props.username.length > 0 &&
      this.props.password != null && this.props.password.length > 0){
        this.sendLoginRequest(this.props.username, this.props.password, false, this.props.loginOKFunction, this.props.loginFailFunction);
      }
  }

  /**
   * POST /api/auth/login — replaces do_login_json.php.
   *
   * The session is now a JWT pair, not a PHPSESSID: nothing depends on the
   * browser storing a cross-origin Set-Cookie any more (that fragility, and the
   * duplicate-PHPSESSID shadowing that came with it, is gone). AuthService keeps
   * the tokens; the callback still receives a superagent-shaped response whose
   * body carries login_result/user_info/school_info, so loginOK is unchanged.
   */
  sendLoginRequest(username, password, rememberMe, loginOKCallback, loginFailedCallback){
    AuthService.login(username, password)
      .then((res) => {
        if (loginOKCallback) {
          // Pass rememberMe flag to the callback
          loginOKCallback(res, rememberMe);
        }
      })
      .catch((err) => {
        if (loginFailedCallback) {
          loginFailedCallback(err);
        }
      });
  }

  render() {
      return (
        <div>

        </div>
      )
  }

}

export default LoginCreateSession;
